import { Map } from 'immutable';
import { PrivilegeChecker } from 'omni-common-ui';
import Privileges from 'domain/Privileges';
import is from 'is_js';
import { actions as groupAction } from 'containers/Group';

export const generateActionButtons = (getState) => ({
  Submit: {
    isPrimary: true,
    route: './publish-all',
    label: ({ params: { progressReportId } }) => {
      try {  // meh.
        return isAnyCommentExist(getState(), progressReportId) ?
          'Submit All for Approval' :
          'Submit All';
      } catch (e) {
        return 'Submit All';
      }
    },
    visibleWhen: ({ params: { groupId, progressReportId } }) =>
      ! groupAction.isDisabledReportActions(getState(), groupId) &&
      PrivilegeChecker.hasPrivilege(getState(), Privileges.ProgressReport.Publish) &&
      ! isFuture(getState(), progressReportId),
    disableWhen: ({ params: { progressReportId } }) =>
      ! isAnyPublishable(getState(), progressReportId),
  },
  'Export All': {
    route: './export-all',
    visibleWhen: ({ params: { groupId, progressReportId } }) =>
      ! groupAction.isHFV4CourseTypeGroup(getState(), groupId) &&
      PrivilegeChecker.hasPrivilege(getState(), Privileges.ProgressReport.Export) &&
        ! isFuture(getState(), progressReportId),
    disableWhen: ({ params: { progressReportId } }) =>
      ! isAnyExportable(getState(), progressReportId),
  },
});

function isFuture(state, progressReportId) {
  const studentReportSummaries = state.get('rootReducer')
    .get('studentReportSummaries')
    .get(`${progressReportId}`)
    .data;
  return studentReportSummaries && studentReportSummaries.size === 0;
}

function isAnyExportable(state, progressReportId) {
  const studentReports = state.get('rootReducer')
    .get('studentReportSummaries')
    .get(progressReportId);
  if (! Map.isMap(studentReports.data)) {
    return false;
  }
  return !! studentReports.data
    .some((report) => report.status && report.status !== 'ScoresMissing');
}

function isAnyPublishable(state, progressReportId) {
  const studentReports = state.get('rootReducer')
    .get('studentReportSummaries')
    .get(progressReportId);
  if (! Map.isMap(studentReports.data)) {
    return false;
  }
  return !! studentReports.data
    .some((report) => report.status === 'Ready');
}

function isAnyCommentExist(state, progressReportId) {
  return state.get('rootReducer')
    .get('studentReportSummaries')
    .get(`${progressReportId}`)
    .data
    .some((studentReportSummary) => {
      if (studentReportSummary &&
  studentReportSummary.comments) {
        return ! is.falsy(studentReportSummary.comments) &&
    studentReportSummary.comments.length > 0;
      }
      return false;
    });
}

export default {
  generateActionButtons,
};



// WEBPACK FOOTER //
// ./containers/Group/ProgressReport/ProgressReportListView/routes.js